export default "__VITE_ASSET__1120501e__"